var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24748 2.5L8.69532 2.69487C6.54637 3.45333 5.47188 3.83257 4.85968 4.69785C4.24748 5.56313 4.24748 6.70258 4.24748 8.9815V11.0185C4.24748 13.2974 4.24748 14.4368 4.85968 15.3022C5.47188 16.1674 6.54637 16.5467 8.69532 17.3052L9.24748 17.5",
    stroke: "#2A2E34",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5808 9.99984H9.24748M17.5808 9.99984C17.5808 9.41634 15.9189 8.32611 15.4975 7.9165M17.5808 9.99984C17.5808 10.5833 15.9189 11.6736 15.4975 12.0832",
    stroke: "#2A2E34",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.f5671a3e6d221c552867dee76cbb6e70.svg";
export { ForwardRef as ReactComponent };